class Session{

  constructor(id, email, token, type,sportPlaceName){
    this.id = id
    this.email = email
    this.token = token
    this.type = type,
    this.sportPlaceName = sportPlaceName
  }

  static parse(responseData){
    let d = responseData
    var sportPlaceName = null
    if(d.admin.sport_place){
      sportPlaceName = d.admin.sport_place.name
    }
    return new Session(d.admin.id, d.admin.email, d.token, d.admin.admin_type,sportPlaceName)
  }
}


export default Session



// WEBPACK FOOTER //
// ./src/models/session.js